import { render, staticRenderFns } from "./UiVideo.vue?vue&type=template&id=2c1b1a4a"
import script from "./UiVideo.vue?vue&type=script&lang=js"
export * from "./UiVideo.vue?vue&type=script&lang=js"
import style0 from "./UiVideo.vue?vue&type=style&index=0&id=2c1b1a4a&prod&lang=scss"
import style1 from "./UiVideo.vue?vue&type=style&index=1&id=2c1b1a4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports